// src/redux/store.js
import { configureStore } from "@reduxjs/toolkit";
import selectOptionsReducer from "../selectSlice";
import apiSlice from "../slice/logdetailSlice"; // Adjust the path
import chatbotApiSlice from "../slice/chatbotApiSlice";

const store = configureStore({
  reducer: {
    selectOptions: selectOptionsReducer,
    [apiSlice.reducerPath]: apiSlice.reducer, // Use the reducerPath defined in the slice
    [chatbotApiSlice.reducerPath]: chatbotApiSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiSlice.middleware, chatbotApiSlice.middleware), // Add RTK Query middleware
});

export default store;
